import React from "react";
import { useDispatch } from "react-redux";
import "./index.scss";

const Tabs = ({ tabs, activeTab, changeActiveTab }) => {
  const dispatch = useDispatch();

  return (
    <div className="selectedtab-wrapper">
      <div className="left-side">
        {tabs?.map((tab, index) => (
          <>
            <div
              key={tab?.value}
              className={`content-tab ${
                activeTab === tab?.value ? "active" : ""
              }`}
              onClick={() => {
                dispatch(changeActiveTab(tab?.value));
              }}
            >
              <div className="content-tab-title">{tab?.label}</div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
